module.exports = __webpack_public_path__ + "img/logo.a660d208.png";